import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import isExternalUrl from 'commons/isExternalUrl';
import normalizeInternalLink from 'commons/normalizeInternalLink';
import useIsBrowser from 'hooks/useIsBrowser';

// This is the secondary navigation menu shown on pages such as Shipping,
// Returns and Warranty. Ideally this should be renamed to a more accurate name,
// and the exported name (used in layouts.json) should be updated accordingly.
const ConsumerMenu = props => {
  const $ = _c(12);
  const isBrowser = useIsBrowser();
  const {
    isAltSubMenu
  } = props;
  let t0;
  if ($[0] !== isBrowser || $[1] !== props.config.navlinks) {
    let t1;
    if ($[3] !== isBrowser) {
      t1 = links => isExternalUrl(links.link) ? <a key={links.link} href={links.link} className="text-xs text-gray m-4 hover:text-brand max-[1023px]:md:mx-[15px] max-[1023px]:md:my-3 no-underline hover:underline font-bold">{links.title}</a> : <Link key={links.link} className={cx("font-bold no-underline hover:underline", {
        "text-xs text-gray m-4 hover:text-brand max-[1023px]:md:mx-[15px] max-[1023px]:md:my-3": true,
        "text-brand": isBrowser && window.location.pathname === links.link
      })} to={normalizeInternalLink(links.link)}>{links.title}</Link>;
      $[3] = isBrowser;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = props.config.navlinks.map(t1);
    $[0] = isBrowser;
    $[1] = props.config.navlinks;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let finalMenuList = t0;
  if (isAltSubMenu) {
    let t1;
    if ($[5] !== isBrowser || $[6] !== props.config.navlinks) {
      let t2;
      if ($[8] !== isBrowser) {
        t2 = links_0 => isExternalUrl(links_0.link) ? <a key={links_0.link} href={links_0.link} className="text-xs text-gray m-4 hover:text-brand max-[1023px]:md:mx-[15px] max-[1023px]:md:my-3 no-underline hover:underline font-bold">{links_0.title}</a> : <Link key={links_0.link} className={cx("font-bold no-underline hover:underline", {
          "text-xs text-gray m-4 hover:text-brand max-[1023px]:md:mx-[15px] max-[1023px]:md:my-3": true,
          "text-brand": isBrowser && window.location.pathname === links_0.link
        })} to={normalizeInternalLink(links_0.link)}>{links_0.title}</Link>;
        $[8] = isBrowser;
        $[9] = t2;
      } else {
        t2 = $[9];
      }
      t1 = props.config.navlinks.map(t2);
      $[5] = isBrowser;
      $[6] = props.config.navlinks;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    finalMenuList = t1;
  }
  let t1;
  if ($[10] !== finalMenuList) {
    t1 = <div className="[border-bottom:1px_solid_#e5e5e5]"><div className="flex justify-start whitespace-nowrap max-w-[1400px] px-5 py-0 overflow-auto [border-top:1px_solid_#f1f1f1] lg:[border-top:0] lg:px-[3.333vw] lg:py-0 min-[1440px]:overflow-hidden [&_a:first-child]:ml-0 max-[767px]:overflow-auto max-[767px]:flex-nowrap [&::-webkit-scrollbar]:max-[767px]:hidden">{finalMenuList}</div></div>;
    $[10] = finalMenuList;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  return t1;
};
ConsumerMenu.propTypes = {
  config: PropTypes.shape({
    borderBottom: PropTypes.bool,
    navlinks: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      link: PropTypes.string
    }))
  }),
  isAltSubMenu: PropTypes.bool
};
export default ConsumerMenu;